import learnerAxiosInstance from "../../utils/learnerAxiosInstance";
import { API_URL } from "../../../src/constants/config";

export const updateLearner = async (accessToken, postParams) => {
    const url = 'learner_profile_update';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response?.data;
}

export const getTimezone = async (accessToken) => {
    const url = 'timezone';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.get(url);
    return response?.data?.data;
}

export const getOrganizations = async (accessToken) => {
    const url = 'organizations';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.get(url);
    return response?.data?.data;
}

export const getCountryCodes = async (accessToken) => {
    const url = 'country_codes';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.get(url);
    return response?.data?.data;
}

export const getProfileFieldBlocks = async (accessToken) => {
    const url = 'profile_blocks';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.get(url);
    return response?.data?.data;
}

export const changePassword = async (accessToken, postParams) => {
    const url = 'change_password';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response?.data;
}

export const updateProfileFields = async (accessToken, postParams) => {
    const url = 'update_profile_fields';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response?.data;
}

export const saveProfileAbout = async (accessToken, postParams) => {
    const url = `${API_URL}dashboard/save_profile_about`;
    const axiosInstance = learnerAxiosInstance(accessToken);

    const formData = new FormData();
    Object.keys(postParams).forEach((key) => {
        formData.append(key, postParams[key]);
    });

    const response = await axiosInstance.post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data", 
        },
    });

    return response?.data;
};
